import { render, staticRenderFns } from "./LgbTeamMembersEdit.vue?vue&type=template&id=8db5a0cc"
import script from "./LgbTeamMembersEdit.vue?vue&type=script&lang=js"
export * from "./LgbTeamMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./LgbTeamMembersEdit.vue?vue&type=style&index=0&id=8db5a0cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports